module.exports = __webpack_public_path__ + "img/logo-QP.6beda65b.svg";